import http from './http';

export default {
  all() {
    return http().get(`/v2/statuses`);
  },
  get(id) {
    return http().get(`/v2/statuses/${id}`);
  },
  create(data) {
    return http().post(`/v2/statuses`, data);
  },
  update(data) {
    return http().put(`/v2/statuses/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v2/statuses/${id}`);
  },
  restore(id) {
    return http().put(`/v2/statuses/${id}/restore`);
  },
}
